import { Button } from 'components/atoms';
import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { PiPlus } from 'react-icons/pi';
import { ISelectOption } from 'types/components/inputs/input.interface';
import './ContractAgreementDetailSelect.scss';
import ContractAgreementDetailSelectOptionsList from './options/ContractAgreementDetailSelectOptionsList';

const ContractAgreementDetailSelect = () => {
  const { values, itemName, setItemAndDetailValue, displayMode } =
    useFormikContractHelpers();
  const { t } = useTranslation();

  const selectAgreementTemplate =
    values.sideMenu?.detail?.content.selectAgreementTemplate;

  const selectOptions =
    selectAgreementTemplate?.options.map((option, key) => ({
      label: option,
      value: key + 1,
    })) ?? [];

  const selectDefaultValue = (option: ISelectOption<string | number>) => {
    setItemAndDetailValue<string>(
      'content.selectAgreementTemplate.defaultValue',
      option.label
    );
  };

  const onAddNewOption = () => {
    const newOption: string = '';
    setItemAndDetailValue<string>(
      `content.selectAgreementTemplate.options[${selectOptions.length}]`,
      newOption
    );
  };

  return (
    <Contract.SideMenu.AgreementDetail.Wrapper
      name={`${itemName}.content.selectAgreementTemplate.title`}
      label={t('input.label.title')}>
      <FormInput.Select
        name={`${itemName}.content.selectAgreementTemplate.defaultValue`}
        label={t('input.label.default-option')}
        onChange={selectDefaultValue}
        options={selectOptions}
        value={
          selectAgreementTemplate
            ? {
                label: selectAgreementTemplate.defaultValue,
                value: selectAgreementTemplate.defaultValue,
              }
            : undefined
        }
        isDisabled={
          !selectOptions.filter(option => !!option.label.length).length
        }
        displayMode={displayMode}
      />
      <p className='flex w-full px-12'>
        {!displayMode
          ? t('contract-template.agreement.options-header')
          : t('contract-template.agreement.options-to-select')}
      </p>
      <div className='contract-details-select-options'>
        <ContractAgreementDetailSelectOptionsList
          selectOptions={selectOptions}
        />
        {!displayMode && (
          <Button onlyIcon isClear fullWidth onClick={onAddNewOption}>
            <Button.Icon icon={<PiPlus />} />
          </Button>
        )}
      </div>
    </Contract.SideMenu.AgreementDetail.Wrapper>
  );
};

export default ContractAgreementDetailSelect;
